import { useState, useEffect } from 'react'

const ExternalVideoPreview = ({ shareSetting }) => {
  const externalUrl = shareSetting.digital_assets[0].external_video_url
  if (!externalUrl) return null
  const { source, url } = externalUrlInformation(externalUrl)
  if (source === 'youtube' || source === 'vimeo') {
    return (
      <iframe
        allowFullScreen
        frameBorder="0"
        height={147}
        src={url}
        title={`${source}-iframe`}
        width={220}
      />
    )
  }
  if (source === 'facebook') return <FacebookVideo height={147} url={url} />
  return null
}

const externalUrlInformation = (externalUrl) => {
  const sourceRegex = {
    facebook: /facebook\.com/,
    youtube:
      /(?:youtube(?:-nocookie)?\.com\/(?:[^/\n\s]+\/\S+\/|(?:v|e(?:mbed)?)\/|\S*?[?&]v=)|youtu\.be\/)([a-zA-Z0-9_-]{11})/,
    vimeo:
      /(http|https)?:\/\/(www\.)?vimeo.com\/(?:channels\/(?:\w+\/)?|groups\/([^/]*)\/videos\/|)(\d+)(?:|\/\?)/,
  }

  const source = Object.keys(sourceRegex).find((key) =>
    externalUrl.match(sourceRegex[key]),
  )

  let url

  // Determine Youtube URL
  if (source === 'youtube') {
    // This is from CP
    let id = ''
    url = externalUrl
      .replace(/(>|<)/gi, '')
      .split(/(vi\/|v=|\/v\/|youtu\.be\/|\/embed\/)/)
    if (url[2] !== undefined) {
      id = url[2].split(/[^0-9a-z_-]/i)
      id = id[0]
    } else {
      id = url
    }
    url = `https://www.youtube.com/embed/${id}`
  }

  // Determine Vimeo URL
  else if (source === 'vimeo') {
    const videoId = externalUrl.substring(
      externalUrl.lastIndexOf('/'),
      externalUrl.length,
    )
    url = `https://player.vimeo.com/video${videoId}`
  }

  // Determine Facebook URL
  else if (source === 'facebook') url = externalUrl

  return { source, url }
}

const FacebookVideo = ({ url, width, height }) => {
  const src = 'https://connect.facebook.net/en_US/sdk.js#xfbml=1&version=v3.2'
  const [loaded, setLoaded] = useState(false)

  useEffect(() => {
    if (window.FB) {
      setLoaded(true)
      return
    }
    let script = document.createElement('script')
    script.src = src
    script.async = true

    const onScriptLoad = () => {
      setLoaded(true)
    }

    script.addEventListener('load', onScriptLoad)

    document.body.appendChild(script)

    return () => {
      script.removeEventListener('load', onScriptLoad)
    }
  }, [])

  return loaded ? (
    <div
      className="fb-video"
      data-allowfullscreen="true"
      data-height={height}
      data-href={url}
      data-width={width}
    />
  ) : null
}

export default ExternalVideoPreview
